import { Api } from "../config/request";

export default {
    BulkCreatePolygon(payload) {
        return Api.post("/polygon/bulk-create", payload);
    },
};